import { ReactElement } from 'react';
import Button from '@components/DesignLibrary/Button';
import CheckCircle from '@components/Icons/CheckCircle';
import WarningCircle from '@components/Icons/WarningCircle';
import Spacer from '@components/Spacer';
import s from './CreditReportModal.module.scss';

type Props = {
  approvalModalResponseType: string;
  nextStep: () => void;
  isB2B?: boolean;
};

const ApprovalRequestSent = ({ approvalModalResponseType, nextStep, isB2B }: Props): ReactElement => (
  <div className={s.confirm}>
    { approvalModalResponseType === 'Success'
      ? <CheckCircle size="48" color="var(--color-success)" weight="fill" />
      : <WarningCircle size={62} weight="fill" color="var(--color-error)" />
    }

    <Spacer size={8} />

    <div className={s.approvalRequestSentText}>
      {isB2B
        ? (
          approvalModalResponseType === 'Success'
            ? (
              'Your credit report has been successfully fetched.'
            )
            : (
              approvalModalResponseType.split('\n').map((line, index) => (
                <div key={index}>{line}</div>
              ))
            )
        )
        : (
          'An approval request has been sent to your client to pull their credit report.'
        )}
    </div>

    <Spacer size={24} />

    <Button variant="primary" size="md" fullWidth onClick={nextStep}>
      {approvalModalResponseType === 'Success' ? 'Done' : 'Cancel'}
    </Button>
  </div>
);

export default ApprovalRequestSent;
